module.exports = __webpack_public_path__ + "static/img/IMG_20151018_152518.c7050fd5.jpg";